'use client'

import {
  Anchor,
  H1,
  H2,
  H3,
  Image,
  Paragraph,
  Separator,
  Sheet,
  XStack,
  YStack,
} from 'tamagui'
import React, { useState } from 'react'
import { Text } from '@tamagui/web'
import { useDataStore } from '@/contexts/DataStoreContext'
import { Button } from './common/Button'
import { LockIcon } from './common/LockIcon'

export function PinUpdateIntro() {

  const { session: { data }, dismissIntro } = useDataStore()

  return (
    <YStack justifyContent='center' alignItems='center' flex={1} p={24} pt={0}>
      <YStack space={40} maxWidth={500}>
        <XStack alignItems='center' justifyContent='center' space="$3">
          <LockIcon />
          <H3 textAlign="center">
            <Text>Secure PIN Update</Text>
          </H3>
        </XStack>
        <YStack space="$4">
          <Paragraph textAlign="center">
            Hey {data?.user?.first_name || 'there'}! 👋 Per your request on the phone, your secure portal is here for you to help manage your Extra card's PIN.
          </Paragraph>
          <Paragraph textAlign="center">
          (Please note this link expires an hour after being sent)
          </Paragraph>
        </YStack>

        <Button alignSelf='center' onPress={dismissIntro}>Continue</Button>
      </YStack>

    </YStack>
  )
}
